import { useEffect, useRef, useState } from 'react';
import { cooperplaceApi } from 'services/api';
import { validateOccurrences } from './contract';

export default function useOccurrences(companyId, travelId, page, revision) {
  const companyScope = companyId == null || companyId === '' ? 'session' : String(companyId);
  const key = `${companyScope}:${travelId}:${page}:${revision}`;
  const generation = useRef(0);
  const [state, setState] = useState({ key: null, loading: true, data: null, error: null });
  useEffect(() => {
    const current = ++generation.current;
    const abort = new AbortController();
    setState({ key, loading: true, data: null, error: null });
    async function read() {
      try {
        if (!Number.isSafeInteger(travelId) || travelId < 1)
          throw new Error('Contexto da viagem não informado.');
        const reply = await cooperplaceApi.get(`control-tower/travels/${travelId}/occurrences`, {
          params: { page },
          signal: abort.signal,
        });
        const data = validateOccurrences(reply.data, travelId, page);
        if (current === generation.current && !abort.signal.aborted)
          setState({ key, loading: false, data, error: null });
      } catch (error) {
        if (current !== generation.current || abort.signal.aborted) return;
        const status = error.response?.status;
        const message = [401, 403].includes(status)
          ? 'Você não tem permissão para consultar as ocorrências.'
          : status === 404
            ? 'Viagem não encontrada ou indisponível para consulta.'
            : error.response || error.isAxiosError
              ? 'Não foi possível consultar as ocorrências. Tente novamente.'
              : error.message;
        setState({ key, loading: false, data: null, error: message });
      }
    }
    read();
    return () => abort.abort();
  }, [key, travelId, page]);
  return state.key === key ? state : { loading: true, data: null, error: null };
}
